var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-main"},[_c('div',{staticClass:"form-main-l"},[_vm._v(_vm._s(_vm.label))]),_c('div',{staticClass:"form-line"}),_c('div',{staticClass:"label-main-t"},[_vm._v(_vm._s(_vm.text))])])}
var staticRenderFns = []

export { render, staticRenderFns }